import { ColumnRow } from './ColumnRow';
import type { Gs1FieldOption, IntakeColumnMappingProposal } from '../intake.api';

/**
 * De kop is geen sleutel: in het verpakkingssjabloon heet elke materiaalgroep zijn kolommen
 * hetzelfde. Gemeten op acceptatie 13-09-2026 — op de kop koppelen liet de tweede kolom niet
 * bevestigen, klapte beide rijen tegelijk open, en gaf React twee kinderen dezelfde sleutel.
 * Daarom loopt alles hier op de positie in het bestand.
 */
export interface ColumnListProps {
  columns: IntakeColumnMappingProposal[];
  activeIndex: number | null;
  gs1Options: Gs1FieldOption[];
  disabled?: boolean;
  onSelect: (index: number) => void;
  onSetField: (index: number, field: string | null) => void;
  onConfirm: (index: number) => void;
  onIgnore: (index: number) => void;
}

export function ColumnList({ columns, activeIndex, gs1Options, disabled, onSelect, onSetField, onConfirm, onIgnore }: ColumnListProps) {
  return (
    <ul data-testid="intake-column-list" className="flex flex-col gap-2">
      {columns.map((column, index) => (
        <ColumnRow
          key={`${index}-${column.header}`}
          column={column}
          isActive={index === activeIndex}
          gs1Options={gs1Options}
          disabled={disabled}
          onSelect={() => onSelect(index)}
          onSetField={(field) => onSetField(index, field)}
          onConfirm={() => onConfirm(index)}
          onIgnore={() => onIgnore(index)}
        />
      ))}
    </ul>
  );
}
